export default "__VITE_ASSET__Bje3HdZ8__"